import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import ArticleIcon from '@mui/icons-material/Article';

/**
 * A TemplateEntry is a ListItem intended to be used for a singular entry in the TemplatePopover component.
 * Clicking on the entry will open a new tab to the target url from the template.
 */
function TemplateEntry({template}){
    return (
        <ListItemButton
            key={template.name}
            href={template.url}
            target="_blank"
            rel="noopener"
        >
            <ListItemIcon>
                <ArticleIcon/>
            </ListItemIcon>
            <ListItemText primary={template.name} />
        </ListItemButton>
    )
} 

export default TemplateEntry